import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { OverlayService } from 'src/app/services/overlay.service';
import { ProductService } from 'src/app/services/product.service';
import { Store } from 'src/app/store';
import { delay } from 'rxjs/operators';

@Component({
    selector: 'app-marketplace',
    templateUrl: './marketplace.component.html',
    styleUrls: ['./marketplace.component.scss'],
})
export class MarketplaceComponent implements OnInit {
    overlays$ = this.store.select<any>('overlays');
    sortTypes = [
        { name: 'Price', val: 'product_details.price' },
        { name: 'Name', val: 'products.name' },
    ];

    totalRecords: number;

    products = [];

    params = {
        limit: 21,
        //limits: [10, 25, 50, 75, 100],
        sort: 'products.name',
        page: 0,
        pages: 0,
        pageArray: [],
        totalRecords: 0,
    };

    form: FormGroup;
    mobileSearch = false;

    constructor(
        private store: Store,
        private overlayService: OverlayService,
        private productService: ProductService,
        private fb: FormBuilder,
        private router: Router
    ) {
        this.form = this.fb.group({
            search: [null],
            sort: ['products.name'],
            type: [null],
            sellUnit: [null],
            minWidth: [null],
            maxWidth: [null],
            randomWidth: [null],
            minLength: [null],
            maxLength: [null],
            randomLength: [null],
            minThickness: [null],
            maxThickness: [null],
            minPrice: [null],
            maxPrice: [null],
            priceMethod: [null],
        });
    }

    minimumPrice = null;
    maximumPrice = null;

    ngOnInit(): void {
        this.loadProducts();
        this.form.valueChanges.pipe(delay(400)).subscribe((filters) => {
            this.loadProducts(filters);
        });
    }

    openFilters() {
        this.overlayService.toggle('marketplaceFilters');
    }

    openProductDetails(slug) {
        this.router.navigate([`/products/marketplace/${slug}`]);
    }

    showMore() {
        this.params.limit = this.params.limit + 21;
        this.loadProducts()
    }

    loadProducts(filters = {} as any) {
        if (filters.randomWidth) {
            filters.minWidth = null;
            filters.maxWidth = null;
        }

        if (filters.randomLength) {
            filters.minLength = null;
            filters.maxLength = null;
        }

        const params = { ...filters, ...this.params, jobLot: 1 };
        this.productService.marketplace(params).subscribe((products) => {
            this.products = products.data.data;
            this.totalRecords = products.data.totalRecords;
            this.calcPaginator();
            if (!this.maximumPrice && !this.maximumPrice) {
                this.calcMinMaxPrices();
            }
        });
    }

    toggleMobileSearch() {
        this.mobileSearch = !this.mobileSearch;
    }

    private calcMinMaxPrices() {
        // this.minimumPrice = Math.min(...this.products.map((p) => p.price));
        this.minimumPrice = 0
        this.maximumPrice = Math.max(...this.products.map((p) => p.price));
    }

    private calcPaginator() {
        this.params.pages = Math.ceil(this.totalRecords / this.params.limit);
        this.params.totalRecords = this.totalRecords;
        this.params.pageArray = [];
        for (let i = 0; i < this.params.pages; i++) {
            this.params.pageArray.push(i);
        }
    }
}
